import { checkLocale } from '../locale';
import { FIRST_DAY, LABELS, MONTHS, WEEKDAYS_LONG, WEEKDAYS_SHORT } from './constants';

var monthOptionsFunc = function monthOptionsFunc(month, index) {
  return {
    label: month,
    value: index
  };
};

export var MONTH_OPTIONS = {
  ru: MONTHS.ru.map(monthOptionsFunc),
  en: MONTHS.en.map(monthOptionsFunc),
  it: MONTHS.it.map(monthOptionsFunc),
  es: MONTHS.es.map(monthOptionsFunc),
  de: MONTHS.de.map(monthOptionsFunc),
  zh: MONTHS.zh.map(monthOptionsFunc),
  el: MONTHS.el.map(monthOptionsFunc)
};
var confirmLabels = {
  zh: '完成',
  ru: 'Готово',
  it: 'Fatto',
  de: 'Erledigt',
  es: '¡Hecho',
  en: 'Done',
  el: 'Ολοκληρώθηκε'
};

function formatDay(d, locale) {
  var localeValue = checkLocale(locale);
  return "".concat(WEEKDAYS_LONG[localeValue][d.getDay()], ", ").concat(d.getDate(), " ").concat(MONTHS[localeValue][d.getMonth()], " ").concat(d.getFullYear());
}

function formatMonthTitle(d, locale) {
  var localeValue = checkLocale(locale);
  return "".concat(MONTHS[localeValue][d.getMonth()], " ").concat(d.getFullYear());
}

function formatDayMonthShortYear(d, locale) {
  var localeValue = checkLocale(locale);
  var currentMonth = MONTHS[localeValue][d.getMonth()];

  if (!currentMonth) {
    return '';
  }

  var shortMonth = currentMonth.slice(0, 3).toLowerCase();
  return "".concat(d.getDate(), " ").concat(shortMonth, " ").concat(d.getFullYear());
}

function formatWeekdayShort(i, locale) {
  var localeValue = checkLocale(locale);
  return WEEKDAYS_SHORT[localeValue][i];
}

function formatWeekdayLong(i, locale) {
  var localeValue = checkLocale(locale);
  return WEEKDAYS_SHORT[localeValue][i];
}

function getFirstDayOfWeek(locale) {
  var localeValue = checkLocale(locale);
  return FIRST_DAY[localeValue];
}

export var getLocale = function getLocale(locale) {
  var localeValue = checkLocale(locale);
  return {
    firstDayOfWeek: FIRST_DAY[localeValue],
    labels: LABELS[localeValue],
    monthOptions: MONTH_OPTIONS[localeValue],
    months: MONTHS[localeValue],
    weekdaysLong: WEEKDAYS_LONG[localeValue],
    weekdaysShort: WEEKDAYS_SHORT[localeValue],
    confirmLabel: confirmLabels[localeValue]
  };
};
export var localeUtils = {
  formatDay: formatDay,
  formatDayMonthShortYear: formatDayMonthShortYear,
  formatMonthTitle: formatMonthTitle,
  formatWeekdayShort: formatWeekdayShort,
  formatWeekdayLong: formatWeekdayLong,
  getFirstDayOfWeek: getFirstDayOfWeek
};